const INITIAL_STATE = {
  library: []
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {

    case 'ADDSONG':
      return {
        ...state,
        library: action.payload
      }

    default:
      return state;
  }
};
export default reducer;
